import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1d1b8d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-numeros" }
const _hoisted_2 = { class: "container-site grade-numeros" }
const _hoisted_3 = { class: "valor-numero" }
const _hoisted_4 = { class: "legenda-numero" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numeros, (numero) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item-numero",
          key: numero.legenda
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(numero.valor), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(numero.legenda), 1)
        ]))
      }), 128))
    ])
  ]))
}